export class CustomerDuplicatePhone {
  phone: string;
  total = 0;
  totalClient = 0;
  totalCustomer = 0;
  isLinked: boolean;
}
